import React from "react";

import { Box, Stack, Typography } from "@mui/material";

import { views } from "utils/virtualTour";

import comparison from "../../../../../../../../assets/images/icons/vtSplash/comparison.png";
import comparisonIcon from "../../../../../../../../assets/images/icons/vtSplash/comparisonIcon.png";
import dollHouse from "../../../../../../../../assets/images/icons/vtSplash/dollhouse.png";
import dollHouseIcon from "../../../../../../../../assets/images/icons/vtSplash/dollhouseIcon.png";
import floorPlan from "../../../../../../../../assets/images/icons/vtSplash/floor.png";
import floorPlanIcon from "../../../../../../../../assets/images/icons/vtSplash/floorplanIcon.png";
import virtualTour from "../../../../../../../../assets/images/icons/vtSplash/virtualtour.png";
import virtualTourIcon from "../../../../../../../../assets/images/icons/vtSplash/virtualtourIcon.png";

import styles from "./styles";

const ViewCards = () => {
  return (
    <Stack sx={styles.container}>
      {views.map(({ title, description }, index) => (
        <Stack sx={styles.viewImageContainer} key={index}>
          <Box
            component={"img"}
            src={
              title === "Dollhouse"
                ? dollHouse
                : title === "FloorPlan"
                ? floorPlan
                : title === "Virtual Tour"
                ? virtualTour
                : comparison
            }
            alt={title}
            sx={styles.viewImage}
          />
          <Stack sx={styles.viewTextContainer}>
            <Box
              component={"img"}
              src={
                title === "Dollhouse"
                  ? dollHouseIcon
                  : title === "FloorPlan"
                  ? floorPlanIcon
                  : title === "Virtual Tour"
                  ? virtualTourIcon
                  : comparisonIcon
              }
              alt={title}
              sx={styles.viewIcon}
            />
            <Stack
              sx={{
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="body2">{title}</Typography>
              <Typography variant="body2">{description}</Typography>
            </Stack>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default ViewCards;
